import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'lib/centralStore';

const _self = (state: RootState) => state.modal;

export const selectIsOpenUploadDocumentModal = createSelector(
  [_self],
  ({ isOpenUploadDocumentModal }) => isOpenUploadDocumentModal
);

export const selectIsOpenUnregistrationModal = createSelector(
  [_self],
  ({ isOpenUnregistrationModal }) => isOpenUnregistrationModal
);

export const selectInfoScommesse = createSelector(_self, (state) => state.infoScommesse);
export const selectIsOpenSimpleInfo = createSelector(_self, (state) => state.isOpenSimpleInfo);
